import { Button, For, Separator, Tag, Text, VStack, Wrap, WrapItem } from '@chakra-ui/react';
import {
  SearchFilterFieldName,
  SearchFilterOptionEnum,
} from '@components/cockpit/panels/notificationSearch/notificationSearch.types';
import { useSearchFilterField } from '@components/cockpit/panels/notificationSearch/useSearchFilterField';
import { Tooltip } from '@components/ui/tooltip';
import { FormattedMessage, useIntl } from 'react-intl';

interface SelectionTabProps {
  field: SearchFilterFieldName;
}

export default function SelectionTab({ field }: Readonly<SelectionTabProps>) {
  const { formatMessage } = useIntl();
  const { selectedItems, setSelectedItems, clearSelectedItems } = useSearchFilterField(field);

  const isFeminine = field === SearchFilterOptionEnum.PLATFORM || field === SearchFilterOptionEnum.ZONES;
  const message = formatMessage(
    {
      id: 'components.notificationSearch.filters.searchFilters.noSelection',
    },
    {
      object: formatMessage({
        id: `components.notificationSearch.filters.searchFilters.type.${field}.singular`,
      }),
      gender: isFeminine ? 'feminine' : 'masculine',
    },
  );

  return (
    <VStack backgroundColor="neutral.800" boxSize="100%" alignItems="flex-start">
      <VStack padding={3} width="100%" gap={3} alignItems="start">
        <Button variant="toggle" size="toggleS" disabled={selectedItems.length === 0} onClick={clearSelectedItems}>
          <FormattedMessage id="global.reset" />
        </Button>
      </VStack>
      <Separator borderColor="neutral.850" />
      <Wrap padding={3} flexWrap="wrap" width="100%" gap={1}>
        <For each={selectedItems} fallback={<Text>{message}</Text>}>
          {(item) => (
            <WrapItem key={item.value}>
              <Tag.Root key={item.value} variant="dark" cursor="default" minWidth="0" flexShrink={1}>
                <Tooltip content={item.label} openDelay={300}>
                  <Tag.Label textOverflow="ellipsis">{item.label}</Tag.Label>
                </Tooltip>
                <Tag.CloseTrigger
                  boxSize="24px"
                  onClick={() => setSelectedItems(selectedItems.filter((selectedItem) => selectedItem !== item))}
                />
              </Tag.Root>
            </WrapItem>
          )}
        </For>
      </Wrap>
    </VStack>
  );
}
